// extracted by mini-css-extract-plugin
export default {"CheckboxWrapper":"Checkbox_CheckboxWrapper__0T3ZD"};